(function () {
  var SELECTOR = '[data-onsolez-marquee]';
  var MOBILE = '(max-width: 989px)';
  var REDUCE = '(prefers-reduced-motion: reduce)';
  var SPEED = 36;
  var instances = [];

  function cards(track) {
    return Array.prototype.slice.call(track.querySelectorAll('.baydoun-trust-card:not(.baydoun-trust-card--clone)'));
  }

  function TrustMarquee(root) {
    this.root = root;
    this.track = root.querySelector('[data-onsolez-marquee-track]');
    this.mobileMq = window.matchMedia(MOBILE);
    this.reduceMq = window.matchMedia(REDUCE);
    this.observer = null;
    this.bound = {
      resize: this.onResize.bind(this),
      visibility: this.onVisibility.bind(this),
      mode: this.applyMode.bind(this)
    };
    this.bind();
    this.applyMode();
  }

  TrustMarquee.prototype.bind = function () {
    window.addEventListener('resize', this.bound.resize, { passive: true });
    document.addEventListener('visibilitychange', this.bound.visibility);
    if (this.mobileMq.addEventListener) this.mobileMq.addEventListener('change', this.bound.mode);
    else this.mobileMq.addListener(this.bound.mode);
    if (this.reduceMq.addEventListener) this.reduceMq.addEventListener('change', this.bound.mode);
    else this.reduceMq.addListener(this.bound.mode);
  };

  TrustMarquee.prototype.clearClones = function () {
    Array.prototype.slice.call(this.track.querySelectorAll('.baydoun-trust-card--clone')).forEach(function (node) {
      node.parentNode.removeChild(node);
    });
  };

  TrustMarquee.prototype.duplicate = function () {
    var self = this;
    this.clearClones();
    cards(this.track).forEach(function (card) {
      var clone = card.cloneNode(true);
      clone.classList.add('baydoun-trust-card--clone');
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('tabindex', '-1');
      self.track.appendChild(clone);
    });
  };

  TrustMarquee.prototype.measure = function () {
    var originals = cards(this.track);
    var clones = this.track.querySelectorAll('.baydoun-trust-card--clone');
    if (!originals.length || !clones.length) return 0;
    return clones[0].offsetLeft - originals[0].offsetLeft;
  };

  TrustMarquee.prototype.enable = function () {
    var self = this;
    this.duplicate();
    this.root.setAttribute('data-onsolez-marquee-active', '');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var shift = self.measure();
        if (shift <= 0) return;
        self.track.style.setProperty('--marquee-shift', shift + 'px');
        self.track.style.setProperty('--marquee-duration', (shift / SPEED) + 's');
      });
    });
    this.watchVisibility();
  };

  TrustMarquee.prototype.disable = function () {
    this.root.removeAttribute('data-onsolez-marquee-active');
    this.root.removeAttribute('data-onsolez-marquee-paused');
    this.track.style.removeProperty('--marquee-shift');
    this.track.style.removeProperty('--marquee-duration');
    this.clearClones();
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  };

  TrustMarquee.prototype.watchVisibility = function () {
    var self = this;
    if (this.observer) this.observer.disconnect();
    if (!('IntersectionObserver' in window)) return;
    this.observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) self.root.removeAttribute('data-onsolez-marquee-paused');
        else self.root.setAttribute('data-onsolez-marquee-paused', '');
      });
    }, { threshold: 0.15 });
    this.observer.observe(this.root);
  };

  TrustMarquee.prototype.applyMode = function () {
    if (this.mobileMq.matches && !this.reduceMq.matches) this.enable();
    else this.disable();
  };

  TrustMarquee.prototype.onResize = function () {
    this.applyMode();
  };

  TrustMarquee.prototype.onVisibility = function () {
    if (document.hidden) this.root.setAttribute('data-onsolez-marquee-paused', '');
    else if (this.mobileMq.matches && !this.reduceMq.matches) {
      this.root.removeAttribute('data-onsolez-marquee-paused');
    }
  };

  TrustMarquee.prototype.destroy = function () {
    this.disable();
    window.removeEventListener('resize', this.bound.resize);
    document.removeEventListener('visibilitychange', this.bound.visibility);
    if (this.mobileMq.removeEventListener) this.mobileMq.removeEventListener('change', this.bound.mode);
    else this.mobileMq.removeListener(this.bound.mode);
    if (this.reduceMq.removeEventListener) this.reduceMq.removeEventListener('change', this.bound.mode);
    else this.reduceMq.removeListener(this.bound.mode);
    this.root.removeAttribute('data-onsolez-marquee-ready');
  };

  function mount(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll(SELECTOR), function (el) {
      if (el.getAttribute('data-onsolez-marquee-ready') === 'true') return;
      el.setAttribute('data-onsolez-marquee-ready', 'true');
      instances.push(new TrustMarquee(el));
    });
  }

  function unmount(section) {
    instances = instances.filter(function (inst) {
      if (!section.contains(inst.root)) return true;
      inst.destroy();
      return false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { mount(document); });
  } else {
    mount(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    unmount(event.target);
    mount(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    unmount(event.target);
  });
})();
